/**
 * The same phone-format check (`/^\+?\d+$/`) and cleanup
 * (`.replace(/[+\s]/g, '')`) were independently duplicated across 7
 * files - AddBooking/EditBooking, AddDiagnosticCenter/
 * EditDiagnosticCenter, Profile, AddUser/EditUser (Admin Medium #12,
 * AUDIT_FIX_LOG.md). They all happened to already agree with each other,
 * so this is a dedup, not a behavior change - but a future correction
 * (e.g. tightening to a real E.164 check) now only needs to happen once.
 */
const PHONE_FORMAT_REGEX = /^\+?\d+$/;

export function isValidPhoneFormat(phone: string): boolean {
  return PHONE_FORMAT_REGEX.test(phone);
}

/**
 * Digit count only (ignores a leading "+") - a separate check from
 * isValidPhoneFormat() above so tightening/loosening the minimum length
 * for one form (e.g. diagnostic centers wanting a real 10-digit number)
 * doesn't silently change what every other consumer of the format check
 * accepts.
 */
export function hasMinimumPhoneDigits(phone: string, minDigits = 10): boolean {
  return phone.replace(/^\+/, '').length >= minDigits;
}

/** Strips the leading "+" and any whitespace, for submission as digits-only. */
export function sanitizePhoneForSubmit(phone: string): string {
  return phone.replace(/[+\s]/g, '');
}
